import cn from "classnames"
import React, {ReactNode} from "react"
import "./wrapper.scss"

type Props = {
  children: ReactNode
  className?: string
}

export const Wrapper = ({children, className}: Props) => {
  return <div className={cn("wrapper", className)}>{children}</div>
}
